import { VcsCheck } from "types/generated";
import { capitalizeFirstLetter } from "utils/strings";

export const VCSCheckLabels: { [key: string]: string } = {
  [VcsCheck.Aggregated]: capitalizeFirstLetter(VcsCheck.Aggregated.toLowerCase()),
  [VcsCheck.Individual]: capitalizeFirstLetter(VcsCheck.Individual.toLowerCase()),
  [VcsCheck.All]:
    capitalizeFirstLetter(VcsCheck.Individual.toLowerCase()) +
    ", " +
    capitalizeFirstLetter(VcsCheck.Aggregated.toLowerCase()),
};
